<template>
  <div>
    <a-drawer :title="`导入素材`" :width="720" :visible="showImportForm" :body-style="{ paddingBottom: '80px' }"
      @close="close">

      <a-form-model ref="form" :model="model" :rules="rules">
        <a-form-model-item label="目录" prop="pid" v-if="treeData.length > 0">
          <a-tree-select v-model="model.pid" style="width: 100%" placeholder="根目录" allow-clear :tree-data="treeData" :disabled='model.action?true:false'
            :replace-fields="replaceFields" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" />
        </a-form-model-item>

        <a-form-model-item label="上传人" prop="worker_id" v-if="!model.action">
          <a-select placeholder="请选择" allow-clear show-search :default-value="model.worker_id" v-model="model.worker_id" option-filter-prop="children">
              <a-select-option :value="worker.id" v-for="worker in workers" :key="worker.id">
                  {{ worker.name }}
              </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="是否转码" prop="is_zm">
          <a-select placeholder="请选择" allow-clear show-search :default-value="model.is_zm" v-model="model.is_zm" option-filter-prop="children">
              <a-select-option :value="item.id" v-for="item in zms" :key="item.id">
                  {{ item.name }}
              </a-select-option>
          </a-select>
        </a-form-model-item>

        <!-- <a-form-model-item label="角标片尾" prop="is_enhance" help="开启后：视频下载完成后自动叠加角标并拼接片尾，额外生成一条「-角标」素材">
          <a-select placeholder="请选择" :default-value="model.is_enhance" v-model="model.is_enhance" option-filter-prop="children">
              <a-select-option :value="item.id" v-for="item in enhances" :key="item.id">
                  {{ item.name }}
              </a-select-option>
          </a-select>
        </a-form-model-item> -->

        <a-form-model-item label="下载模版" help="点击下载模版">
          <a :href="templateUrl" target="_blank">下载模版</a>
        </a-form-model-item>

        <a-form-model-item label="表格文件" prop="file" help="仅支持xls,xlsx文件格式, 导入后会直接转码">
          <a-upload accept=".xls,.xlsx" :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
            <a-button v-if="fileList.length === 0"> <a-icon type="upload" /> 选择文件 </a-button>
          </a-upload>
        </a-form-model-item>

       

      </a-form-model>

      <div :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }">
        <a-button @click="close" :disabled="loading" :style="{ marginRight: '8px' }">
          取消
        </a-button>
        <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
      </div>


    </a-drawer>
  </div>
</template>

<style lang="less" scoped>
@import 'ImportMaterial';
</style>

<script>
import ImportMaterial from './ImportMaterial'

export default ImportMaterial
</script>
